module.exports = __webpack_public_path__ + "static/media/flag-jp.d38a98a2.webp";